import ChatDetailInfoUpdate from '@/screens/ChatDetailInfoUpdate';

export default function PrivateChatChatIdInfoUpdateRoute() {
  return <ChatDetailInfoUpdate />;
}
